import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import Img from 'components/Image';
import Link from 'components/Link';
import hexColoredSmall from 'utils/images/hex-colored-small.svg';
import WL from 'constants/whiteLabel';
import gs from 'pages/pages.module.css'
import s from 'pages/homeStyles.module.css'
import style from './integration.module.css';

const Integration = () => (
  <section className={cx(style.root, gs.content, s.hiveosContent)}>
    {WL.showHexImg ? <img alt="hex" className={cx(s.drop1, s.__oneSolution)} src={hexColoredSmall} /> : null}
    <div className={gs.backgroundHeader}>integration</div>
    <div className={cx(gs.wrapper, s.wrapper)}>
      <div className={gs.relative}>
        <div className={style.transfromToLeft}>
          <Img className={s.screen} src="integration.png" alt="integration" />
        </div>
      </div>
      <div className={style.text}>
        <h2><FormattedMessage id="Integration.title" defaultMessage="Seamless integration with Hive OS" /></h2>
        <p className={gs.subheader}>
          <FormattedMessage
            id="Integration.caption1"
            defaultMessage="{free} for Hiveon ASIC users"
            values={{ free: <span className={style.orange}><FormattedMessage id="Integration.free" defaultMessage="Free" /></span> }}
          />
          *
        </p>
        <div>
          <FormattedMessage id="Integration.caption2" defaultMessage="Monitor all your ASICs from anywhere, check hashrates, chip errors, power consumption levels, remote troubleshooting and perform bulk updates across your entire farm." />
        </div>
        <br />
        <div>*<FormattedMessage id="Integration.caption3" defaultMessage="Billing is still charged for other workers in the system" /></div>
      </div>
    </div>
    <div className={style.fullWidth}>
      <div className={cx(style.fullWidthItem)}>
        <div><b><FormattedMessage id="Integration.caption4" defaultMessage="Moreover, you get:" /></b></div>
        <div>- <FormattedMessage id="Integration.caption5" defaultMessage="Built-in wattmeter in the web interface;" /></div>
        <div>- <FormattedMessage id="Integration.caption6" defaultMessage="Temperature and hashrate watchdogs;" /></div>
      </div>

      <div className={style.fullWidthBtnItem}>
        <Link external noRef href={WL.getRegisterLink()} className="btn-primary-big">
          <FormattedMessage id="Integration.startMining" defaultMessage="Start Mining" />
        </Link>
      </div>
    </div>

  </section>
)

export default Integration;
